import { Dialog } from '@myosh/odin-components';
import { useRef } from 'react';
import type { LinkedUser } from '../../../../@types/users';
import UserDetails from '../../../admin/user/user-details.component';

interface CreateUserDialogProps {
  header: string;
  visible: boolean;
  hidden: () => void;
  onUserCreated: (user: LinkedUser) => void;
  createExternalUser?: boolean;
}

export default function CreateUserDialog({
  header,
  visible,
  hidden,
  onUserCreated,
  createExternalUser,
}: CreateUserDialogProps) {
  const linkedUser = useRef<LinkedUser | undefined>(undefined);

  const onClose = () => {
    if (linkedUser.current) {
      onUserCreated(linkedUser.current);
      linkedUser.current = undefined;
    }
    hidden();
  };

  const handleLinkedUserCreated = (id: number, firstName: string, lastName: string) => {
    linkedUser.current = { value: id, text: lastName.toUpperCase() + ' ' + firstName };
  };

  return (
    <Dialog header={header} visible={visible} onClose={hidden} fullScreen>
      <UserDetails
        isLinkedUser={true}
        createExternalUser={createExternalUser}
        onLinkedUserCreated={handleLinkedUserCreated}
        onClose={onClose}
        isNewUser={true}
      />
    </Dialog>
  );
}
